import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=fd542a3a&scoped=true&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"
import style0 from "./Text.vue?vue&type=style&index=0&id=fd542a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd542a3a",
  null
  
)

export default component.exports